import { orchestrator } from 'satcheljs';
import { reorderAssetChildren } from '../actions';
import { reorderOutlookSpaceAssetChildren } from '../service';
import { upsertClientAssets } from '../privateActions';
import resolveAssetId from '../assetId/resolveAssetId';

orchestrator(reorderAssetChildren, async ({ projectId, assetId }) => {
    const resolvedAssetId = await resolveAssetId(assetId);
    if (resolvedAssetId) {
        const updatedChildren = await reorderOutlookSpaceAssetChildren(projectId, resolvedAssetId);
        upsertClientAssets(projectId, updatedChildren);
    }
});
